/**
 * Resultsgate API
 * Open API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NewAnimalDTO { 
    age?: string;
    categoryId?: number;
    categoryInfo?: string;
    certificateId?: string;
    dateOfBirth?: string;
    furColor?: string;
    location?: string;
    name?: string;
    rfid?: string;
    sex?: string;
    tattooId?: string;
}

